import { envService } from '@/core/services/env'
import { createAuthServer } from './firebase-auth-server'
import {
  createMessagesListener,
  createRequestNotificationPermission,
} from './firebase-messaging'

export const authServer = createAuthServer({
  envService,
})

export const onForegroundMessage = createMessagesListener({ envService })

export const requestNotificationPermission =
  createRequestNotificationPermission({ envService })
